export default "__VITE_ASSET__2a106630__"